import React, { useState } from 'react';
import Logo from '../Logo';
import { Button } from '../ui/button';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
    onMenuClick();
  };

  const handleJoinWaitlist = () => {
    window.open('https://cop855u0.forms.app/surepal-waitlist', '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b h-16 flex items-center justify-between px-6" style={{ borderColor: 'var(--card-shadow)' }}>
      {/* Logo */}
      <div className="flex items-center">
        <Logo className="h-8 w-auto" />
      </div>

      {/* Menu Button */}
      <button
        onClick={handleMenuClick}
        className="w-11 h-11 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-colors"
        aria-label="Open menu"
      >
        <div className="grid grid-cols-3 gap-1">
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              className="w-1.5 h-1.5 bg-gray-600 rounded-full"
            />
          ))}
        </div>
      </button>

      {/* Menu Dropdown */}
      {isMenuOpen && (
        <div className="absolute top-16 right-6 bg-white border rounded-lg shadow-lg py-2 min-w-48" style={{ borderColor: 'var(--card-shadow)', boxShadow: '0 4px 16px var(--card-shadow)' }}>
          <div className="px-4 py-2 border-b border-gray-100">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                <span className="text-sm font-medium text-gray-600">U</span>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">User</p>
                <p className="text-xs text-gray-500">Demo User</p>
              </div>
            </div>
          </div>
          <div className="px-2 py-1">
            <Button
              onClick={handleJoinWaitlist}
              className="w-full justify-start h-10 px-3 text-sm font-medium"
              variant="ghost"
            >
              Join Waitlist
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
